export const Mastercard = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="12"
    viewBox="0 0 20 12"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1476 10.0245C9.17252 10.8562 7.90765 11.3583 6.5255 11.3583C3.44149 11.3583 0.941406 8.85857 0.941406 5.77498C0.941406 2.69139 3.44149 0.19165 6.5255 0.19165C7.90765 0.19165 9.17252 0.693732 10.1476 1.52543C11.1227 0.693732 12.3876 0.19165 13.7697 0.19165C16.8538 0.19165 19.3538 2.69139 19.3538 5.77498C19.3538 8.85857 16.8538 11.3583 13.7697 11.3583C12.3876 11.3583 11.1227 10.8562 10.1476 10.0245Z"
      fill="#ED0006"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1475 10.0245C11.3481 9.00045 12.1094 7.47661 12.1094 5.77498C12.1094 4.07335 11.3481 2.54952 10.1475 1.52543C11.1226 0.693731 12.3874 0.19165 13.7696 0.19165C16.8536 0.19165 19.3537 2.69139 19.3537 5.77498C19.3537 8.85857 16.8536 11.3583 13.7696 11.3583C12.3874 11.3583 11.1226 10.8562 10.1475 10.0245Z"
      fill="#F9A000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1475 10.0245C11.3481 9.00037 12.1095 7.47654 12.1095 5.77492C12.1095 4.0733 11.3481 2.54948 10.1475 1.52539C8.94686 2.54948 8.18555 4.0733 8.18555 5.77492C8.18555 7.47654 8.94686 9.00037 10.1475 10.0245Z"
      fill="#FF5E00"
    />
  </svg>
);
